const bannerRouter = {
  route: null,
  name: null,
  title: '轮播图管理',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-tushuguanli',
  filePath: 'view/banner/', // 文件路径
  order: null,
  inNav: true,
  children: [
    {
      title: '添加Banner位',
      type: 'view',
      name: 'BannerCreate',
      route: '/banner/add',
      filePath: 'view/banner/banner-create.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: '添加Banner项',
      type: 'view',
      name: 'BannerItemCreate',
      route: '/banner-item/add',
      filePath: 'view/banner/banner-item-create.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: 'Banner位列表',
      type: 'view',
      name: 'BannerList',
      route: '/banner/list',
      filePath: 'view/banner/banner-list.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: 'Banner项列表',
      type: 'view',
      name: 'BannerItemList',
      route: '/banner-item/list',
      filePath: 'view/banner/banner-item-list.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
  ],
}

export default bannerRouter
